import { useDrag } from '@use-gesture/react';
import clsx from 'clsx';
import { type KeyboardEventHandler } from 'react';

import { knob, transparentDraggingArea } from './SelectionArea.sty.js';
import {
  KNOB_HEIGHT,
  KNOB_WIDTH,
  SELECTED_AREA_RADIUS,
} from '../overlays/constants.js';

interface KnobProps {
  /** Coordinate x for knob */
  x: number;
  /** Coordinate x for knob */
  y: number;
  onKeyDown: KeyboardEventHandler;
  interactable: boolean;
  onDragMove: (x: number) => void;
  onDragStart: () => void;
  onDragEnd: () => void;
  /** Makes the element accessible through keyboard */
  focusable?: boolean;
}

export const Knob = ({
  y,
  x,
  interactable,
  onKeyDown,
  focusable,
  onDragMove,
  onDragStart,
  onDragEnd,
}: KnobProps) => {
  const dragHandlers = useDrag(
    ({ xy, type }: { xy: number[]; type: string }) => {
      if (type === 'pointerdown') {
        onDragStart();
      } else if (type === 'pointerup') {
        onDragEnd();
      } else {
        onDragMove(xy[0]);
      }
    },
    {},
  );

  return (
    <>
      {/* Transparent dragging area */}
      <rect
        y={y - KNOB_HEIGHT / 2}
        x={x - (KNOB_WIDTH / 2) * 2}
        className={clsx(transparentDraggingArea)}
        style={{
          pointerEvents: interactable ? 'all' : 'none',
        }}
        {...dragHandlers()}
      />
      {/* Knob */}
      <rect
        y={y}
        x={x}
        rx={SELECTED_AREA_RADIUS}
        className={clsx(knob, 'knob')}
        tabIndex={focusable ? 0 : -1}
        onKeyDown={onKeyDown}
      />
    </>
  );
};
